import type { PixelPoint } from "./snapping";

/** Pas angulaire des segments contraints : horizontales, verticales et diagonales. */
export const CONSTRAINED_ANGLE_STEP_DEG = 45;

/**
 * Ramène le segment `from` → `cursor` sur la direction autorisée la plus proche (multiples de
 * `stepDeg`, en espace écran), en gardant la projection du curseur sur cette direction.
 */
export function constrainAnglePx(from: PixelPoint, cursor: PixelPoint, stepDeg = CONSTRAINED_ANGLE_STEP_DEG): PixelPoint {
  const dx = cursor.x - from.x;
  const dy = cursor.y - from.y;
  if (!dx && !dy) return cursor;

  const step = (stepDeg * Math.PI) / 180;
  const angle = Math.round(Math.atan2(dy, dx) / step) * step;
  const ux = Math.cos(angle);
  const uy = Math.sin(angle);
  const length = dx * ux + dy * uy;

  return { x: from.x + ux * length, y: from.y + uy * length };
}

/** Coin opposé d'un carré ancré en `anchor` : le plus grand des deux côtés, du côté du curseur. */
export function constrainSquarePx(anchor: PixelPoint, cursor: PixelPoint): PixelPoint {
  const dx = cursor.x - anchor.x;
  const dy = cursor.y - anchor.y;
  const side = Math.max(Math.abs(dx), Math.abs(dy));

  return { x: anchor.x + (dx < 0 ? -side : side), y: anchor.y + (dy < 0 ? -side : side) };
}
